import { render } from "./BookItem.vue?vue&type=template&id=10f7c1a4"
import script from "./BookItem.vue?vue&type=script&lang=js"
export * from "./BookItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__